import {
	Component,
	OnInit,
	AfterViewInit,
	ElementRef,
	Renderer,
	ChangeDetectorRef,
	ViewChild,
	OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ToasterService, ToasterConfig, Toast } from 'angular2-toaster';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { CookieService } from "angular2-cookie/core";

import { Model } from '../model/model';
import { ModelFavorites } from '../model/model-favorites';
import { Quote } from '../model/quote';
import { Adjustment } from '../model/adjustment';
import { Constants } from "../model/constants";

import { OrderByPipe } from '../pipes/orderby.pipe';

import { ModelService } from '../services/model.service';
import { FacilityService } from '../services/facility.service';
import { ProductLineService } from '../services/product-line.service';
import { UserFavoritesService } from '../services/user-favorites.service';
import { ApplicationStateService } from '../services/application-state.service';
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { PageTitleService } from "../services/page-title.service";
import { FilterModelsService } from "../services/filter-models.service";
import { InformationAsideModelsService } from "../services/information-aside-models.service";
import { QuoteInfoService } from "../services/quote-info.service";
import { QuoteSummaryService } from "../services/quote-summary.service";
import { CurrentUserService } from "../services/current-user.service";
import { BrowserWidthService } from "../services/browser-width.service";
import { HttpResponseService } from '../services/httpresponse-service';

import { ModalDialogService } from '../reusable-components/modal-dialog/modal-dialog.service';

import * as _ from 'lodash';

@Component({
    selector: 'my-model-list',
    template: require('./model.component.html'),
    styles: [require('./model.component.scss')]
})
export class ModelsComponent implements OnInit, AfterViewInit, OnDestroy {
    _modelCache: Model[];
    _modelFavoritesCache: ModelFavorites[];
    search: Observable<any>;
    quote: Quote;
    adjustment: Adjustment;

    bedroomCount: number = null;
    favoriteUpdated: BehaviorSubject<number> = new BehaviorSubject(null);
    quoteId: number;
    currentUserId: number;
    pricingView: number;
    infinity: number = Infinity;
    showPricingView: boolean;

    searchValue: string;
    searchPipeValue: string;
    stateError: string = '';
    bedroomsFilter: string;
    squareFootage: string;
    searchTerm: string;
    bedroomFilterButton: string = 'All Bedrooms';
    squareFootageFilterButton: string = 'All Sizes';
    mchBaseUrl: string;

    showFavorites: boolean;
    displayFilter: boolean = false;
    showOnlyFavorites: boolean;
    showSearch: boolean;
    showingDeactivateModal: boolean = false;
    stateIsInvalid: boolean = false;

    config: ToasterConfig = new ToasterConfig({
        positionClass: this.browserWidthService.getDisplayMode().width.innerWidth < 769 ? 'toast-bottom-full-width' : 'toast-bottom-right',
        tapToDismiss: false
    });
    toast: Toast;

    @ViewChild('search') input: ElementRef;

    subscription: Subscription = new Subscription();

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public rd: Renderer,
        public cdr: ChangeDetectorRef,
        public ref: ElementRef,
        public facilityService: FacilityService,
        public productLineService: ProductLineService,
        public userFavoritesService: UserFavoritesService,
        public orderBy: OrderByPipe,
        public applicationStateService: ApplicationStateService,
        public toasterService: ToasterService,
        public spinner: LoadingSpinnerService,
        public pageTitleService: PageTitleService,
        public filterModelsService: FilterModelsService,
        public informationAsideModelsService: InformationAsideModelsService,
        public quoteInfoService: QuoteInfoService,
        public quoteSummaryService: QuoteSummaryService,
        public modalDialogService: ModalDialogService,
        public cookieService: CookieService,
        private modelService: ModelService,
        public currentUserService: CurrentUserService,
        public browserWidthService: BrowserWidthService,
        private httpResponseService: HttpResponseService
    ) {
        const routeParamsSub = this.route.params.subscribe(x => {
            this.quoteId = x['quoteId'];
            this.quoteInfoService.quoteId$.next(this.quoteId);
        });
        this.subscription.add(routeParamsSub);

        this.pageTitleService.pageTitle.next({ title: Constants.CmhConnectionTitle });
        this.pageTitleService.pageName.next('Model');

        const currentPricingViewSub = this.quoteInfoService.currentPricingView$.subscribe(x => {
            this.pricingView = x;
            this.quoteSummaryService.calculatePrices();
            this.calculateBasePrices();
        });
        this.subscription.add(currentPricingViewSub);

        const bedRoomsSub = this.filterModelsService._bedRooms.subscribe(x => this.bedroomsFilter = x);
        this.subscription.add(bedRoomsSub);

        const squareFootageSub = this.filterModelsService._squareFootage.subscribe(x => this.squareFootage = x);
        this.subscription.add(squareFootageSub);

        const showOnlyFavoritesSub = this.filterModelsService._showOnlyFavorites.subscribe(x => this.showOnlyFavorites = x);
        this.subscription.add(showOnlyFavoritesSub);

        const showPricingViewSub = this.quoteInfoService.showPricingView$.subscribe(x => {
            this.showPricingView = x;
        });
        this.subscription.add(showPricingViewSub);

        this.mchBaseUrl = this.cookieService.get('mchBaseUrl');

        const currentUserSub = this.currentUserService.currentUser$.subscribe(cu => {
            if (cu !== undefined && cu !== null) {
                this.currentUserId = cu.CmhUserId || cu.cmhUserId;
            }
        });
        this.subscription.add(currentUserSub);
    }

    ngOnInit() {
        this.spinner.showSpinner();
        this.showFavorites = true;
        this.searchValue = '';
        this.searchPipeValue = '';
        this._modelCache = new Array<Model>();

        //let quote = this.applicationStateService.getQuote();
        if (this.quoteId) {
            this.applicationStateService.refreshStateFromDB(this.quoteId, true)
                .subscribe(
                    (dbQuote => {
                        if (dbQuote !== undefined && dbQuote !== null) {
                            this.quote = dbQuote;
                            this.pageTitleService.pageTitle.next({
                                title: Constants.CmhConnectionTitle,
                                subTitle: Constants.CurrentQuoteSubTitle + (
                                    dbQuote.iseriesQuoteNumber > 0 && dbQuote.QuoteStatusesID > 0
                                        ? dbQuote.iseriesQuoteNumber
                                        : this.quoteId
                                )
                            });
                            this.quoteInfoService.quote$.next(dbQuote);
                            const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$
                                .subscribe(
                                    (canAccessQuote => {
                                        if (canAccessQuote === true) {
                                            if (dbQuote.productLineId === undefined || dbQuote.productLineId === null || dbQuote.productLineId === 0) {
                                                this.stateIsInvalid = true;
                                                this.modalDialogService.showMessage({
                                                    headerText: Constants.NoProductLineHeader,
                                                    message: Constants.NoProductLineMessage
                                                }).subscribe(messageReply => {
                                                    this.redirectRequired(false);
                                                });
                                            } else {
                                                this.quoteSummaryService.getPricingHeader(dbQuote.quoteId).subscribe(
                                                    (x => {
                                                        this.adjustment = x.AdjustmentInfo !== undefined && x.AdjustmentInfo !== null ? x.AdjustmentInfo : new Adjustment();
                                                        this.InitializeLists()
                                                            .subscribe(
                                                                data => { },
                                                                error => { this.spinner.hideSpinner(); this.httpResponseService.httpErrorResponse$.next(error); });
                                                    }),
                                                    error => { this.spinner.hideSpinner(); this.httpResponseService.httpErrorResponse$.next(error); });
                                            }
                                        } else {
                                            this.spinner.hideSpinner();
                                        }
                                    }),
                                    (error => {
                                        this.toasterService.pop('error', 'Error has occurred.', error);
                                        this.spinner.hideSpinner();
                                    }),
                                    (() => { this.spinner.hideSpinner(); })
                                );
                            this.subscription.add(canAccessQuoteSub);
                        } else {
                            this.stateIsInvalid = true;
                            this.modalDialogService.showMessage({
                                headerText: 'Choose Model',
                                message: Constants.QuoteNotFoundMessage.replace('#quoteid#', this.quoteId.toString())
                            }).subscribe(messageReply => {
                                this.redirectRequired(true);
                            });
                        }
                    }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
            );
        } else {
            this.modalDialogService.showMessage({
                headerText: 'Choose Model',
                message: Constants.QuoteNotFoundMessage.replace('#quoteid#', this.quoteId.toString())
            }).subscribe(messageReply => {
                this.redirectRequired(true);
            });
        }
    }

    ngOnDestroy() {
        this.pageTitleService.pageName.next(null);
        this.subscription.unsubscribe();
    }

    ngAfterViewInit() {
        this.search = Observable.fromEvent(this.input.nativeElement, 'keyup').debounceTime(250);
        this.input.nativeElement.value = '';

        const searchSub = this.search.subscribe(x => { this.searchTerm = x.target.value; });
        this.subscription.add(searchSub);
    }

    showFilter() {
        this.filterModelsService.showFilter();
    }

    redirectRequired(newQuotesRedirect: boolean) {
        if (newQuotesRedirect) {
            this.router.navigate([Constants.NewQuotesUrl]);
        } else {
            window.location.href = `${this.mchBaseUrl}/${([Constants.ProductLineUrl.replace('#quoteid#', this.quoteId.toString())])}`;
        }
    }

    InitializeLists() {
        return this.productLineService.getProductLine(this.quote.productLineId)
            .map(prod => {
                this.userFavoritesService.getModelFavorites(this.quote.userId).map(mf => {
                    this._modelFavoritesCache = mf;
                    this._modelCache = prod.Models;
                    mf.forEach(fave => {
                        let modelFave = this._modelCache.find(x => x.ModelId === fave.ModelId);
                        if (modelFave !== undefined) {
                            modelFave.Favorite = true;
                        }
                    });
                    if (this._modelCache !== undefined && this._modelCache !== null && this._modelCache.length > 0) {
                        this._modelCache.forEach((mo) => {
                            mo.AdjustedBasePrice = mo.BasePrice;
                        });
                    }
                    this.calculateBasePrices();
                }).subscribe(
                    (data => { }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
                    () => { this.spinner.hideSpinner(); }
                );
            });
    }

    favoriteItem(model: Model, e: Event) {
        e.stopPropagation();
        let modelFavoriteItem = new ModelFavorites();
        modelFavoriteItem.UserId = this.quote.userId;
        modelFavoriteItem.ModelId = model.ModelId;

        this.userFavoritesService.createModelFavorite(modelFavoriteItem)
            .subscribe(
                (mf => {
                    model.Favorite = true;
                    this.userFavoritesService.getModelFavorites(this.quote.userId, true)
                        .subscribe(
                            (mfDB => {
                                this._modelFavoritesCache = mfDB;
                                this.favoriteUpdated.next(Math.random());
                            }),
                            (error => {
                                this.spinner.hideSpinner();
                                this.httpResponseService.httpErrorResponse$.next(error);
                            }),
                            (() => { this.spinner.hideSpinner(); })
                        );
                }),
                (error => {
                    this.spinner.hideSpinner();
                    this.httpResponseService.httpErrorResponse$.next(error);
                }),
        );
    }

    unfavoriteItem(model: Model, e: Event) {
        e.stopPropagation();
        let mf = this._modelFavoritesCache.find(x => x.ModelId === model.ModelId);
        if (mf !== undefined) {
            this.userFavoritesService.deleteModelFavorite(mf.UserFavoriteId)
                .subscribe(
                    (success => {
                        this.userFavoritesService.getModelFavorites(this.quote.userId, true)
                            .subscribe(
                                (mfDB => {
                                    this._modelFavoritesCache = mfDB;
                                    this.favoriteUpdated.next(Math.random());

                                    model.Favorite = false;
                                    let modelCache = this._modelCache.find(x => x.ModelId === model.ModelId);
                                    if (modelCache !== undefined) {
                                        modelCache.Favorite = false;
                                    }
                                }),
                                (error => {
                                    this.spinner.hideSpinner();
                                    this.httpResponseService.httpErrorResponse$.next(error);
                                }),
                        );
                    }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
            );
        }
    }

    updateBedrooms(numBedrooms: string) {
        this.bedroomFilterButton = numBedrooms + ' Bedrooms';
        this.filterModelsService._bedRooms.next(numBedrooms);
    }

    resetBedroomFilter() {
        this.bedroomFilterButton = 'All Bedrooms';
        this.filterModelsService._bedRooms.next('1,2,3,4');
    }

    resetSquareFootageFilter() {
        this.squareFootageFilterButton = 'All Sizes';
        this.filterModelsService._squareFootage.next({
            min: 0,
            max: Infinity
        });
    }

    updateSquareFootage(minSquareFootage: number, maxSquareFootage: number) {
        this.squareFootageFilterButton = Number(minSquareFootage) === 1 ? '1000 +' : minSquareFootage + ' +';
        this.filterModelsService._squareFootage.next({ min: Number(minSquareFootage), max: Number(maxSquareFootage) });
    }

    updateShowOnlyFavorites(e: boolean) {
        this.filterModelsService._showOnlyFavorites.next(e);
    }

    calculateBasePrices() {
        if (this._modelCache !== undefined && this._modelCache !== null && this._modelCache.length > 0) {
            if (this.pricingView === 1 && this.adjustment !== undefined && this.adjustment !== null) {
                this._modelCache.forEach((mo) => {
                    mo.AdjustedBasePrice = (this.adjustment.baseAdjustmentPercent !== undefined && this.adjustment.baseAdjustmentPercent !== 0)
                        ? (mo.AdjustedBasePrice * (1 + (this.adjustment.baseAdjustmentPercent / 100)))
                        : (mo.AdjustedBasePrice + this.adjustment.baseAdjustmentFlat);
                });
            } else {
                this._modelCache.forEach((mo) => {
                    mo.AdjustedBasePrice = mo.BasePrice;
                });
            }
        }
    }

    canDeactivate(): boolean {
        if (this.quoteInfoService.creatingBaseOptions$.value === true) {
            return false;
        } else {
            if (this.quoteInfoService.canAccessQuote$.value === true && !this.stateIsInvalid && this.modelService.navigateBackToProductLine$.value === false) {
                let modelId = this.applicationStateService.getQuote().modelId;
                if ((modelId !== undefined && modelId !== null && modelId !== 0)
                    || (this.quote.modelId !== undefined && this.quote.modelId !== null && this.quote.modelId !== 0)) {
                    return true;
                }
                if (!this.showingDeactivateModal) {
                    this.showingDeactivateModal = true;
                    this.modalDialogService.showMessage({
                        headerText: 'Choose Model',
                        message: 'Please select a Model to continue.'
                    }).subscribe(messageReply => {
                        this.showingDeactivateModal = false;
                    });
                    return false;
                }
            } else {
                return true;
            }
        }
    }

    handleSubscriptionError(error: any) {
        this.toasterService.pop('error', 'Error has occurred.', error);
        console.log('Error => ', error);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model-component/model.component.ts